import SubLabel from "components/Atoms/Sublabel";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import React from "react";
import { getCityStateCountry } from "shared/utils/addressUtils";
import { RemovableLabel, RemovableProps } from "./Removable";

const RemovableVenue = (props: RemovableProps<server.dto.VenueSmall>) => {
  return <RemovableLabel {...props}>
    <div>
      <CompanySidePanel
        type="venue"
        companyId={props.value.venueId}
        trigger={<a>{props.value.name}</a>}
      />
      <SubLabel>{getCityStateCountry(props.value.address)}</SubLabel>
    </div>
  </RemovableLabel>
};

export default RemovableVenue;
